'use strict';

exports.__esModule = true;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _pageActions = require('../actions/page-actions');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _footer = require('../../../footer');

var _headHelmet = require('../../../head-helmet');

var _doctifyUtils = require('doctify-utils');

var _reduxSimpleAuth = require('redux-simple-auth');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalActions = _doctifyGlobalRedux2.default.globalActions;

var SignUpModalActions = globalActions.SignUpModalActions;


var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var LoginPage = function LoginPage(props) {
	if (props.isAuthenticated) {
		var account = props.session.selectedProfile;

		if (typeof ga == "function") {
			ga('set', 'userId', account.id);
		}

		if ((typeof analytics === 'undefined' ? 'undefined' : (0, _typeof3.default)(analytics)) == "object") {
			try {
				analytics.identify(account.id, {
					email: props.session.email,
					type: account.type,
					name: account.name,
					birthday: account.attributes.birthdate,
					firstName: account.firstName,
					lastName: account.lastName
				}, {
					integrations: {
						Intercom: {
							user_hash: props.session.intercomHash
						}
					}
				});
			} catch (e) {
				console.error("CSID error");
			}
		}

		/**
  	If we are already logged in or we log in, let's go to our profile!
  	We are using the good old window.location.href to force navigation
  	to the angular website for now.
  **/
		if (typeof window !== 'undefined') {
			window.location.href = account ? account.type === 'specialist' && '/' + account.type + '/' + account.id + '/edit/profile' || account.type === 'practice' && '/' + account.type + '/' + account.id + '/edit/profile' || account.type === 'patient' && '/' + account.type + '/' + account.id + '/edit' || '/' : '/';
		}
	}

	var validateEmail = function validateEmail(email) {
		var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	};

	var attemptSubmit = function attemptSubmit(event) {
		props.page.validationError();
		event.preventDefault();
	};

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			'div',
			{ id: _style2.default.LoginPage },
			_react2.default.createElement(_headHelmet.HeadHelmet, {
				pageTitle: 'Login to Doctify - find and book a specialist',
				pageContent: 'Find the best doctors and health specialists near you. Book doctor appointments online. Read verified doctor reviews by patients. Doctify is a free service.',
				pageImage: (0, _doctifyUtils.getResourcePath)('/img/logo-dark.svg')
			}),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.content },
				_react2.default.createElement(
					'div',
					{ className: _style2.default.heading },
					_react2.default.createElement(
						'p',
						null,
						props.isAuthenticated ? 'You are logged in!' : 'Welcome back!'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _style2.default.body },
					_react2.default.createElement(
						'form',
						{ className: 'form-horizontal' },
						_react2.default.createElement(
							'div',
							{ className: 'form-group ' + _style2.default.emailInputContainer },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12' },
								_react2.default.createElement(
									'div',
									{ className: 'df-input-group' },
									_react2.default.createElement('i', { className: 'ion-ios-contact' }),
									_react2.default.createElement('input', {
										id: 'emailInput',
										className: 'form-control ' + ((props.page.error || props.page.submitAttempted && !props.page.validEmail) && _style2.default.inputError),
										onChange: function onChange(event) {
											props.pageActions.updateEmail(event.target.value);
										},
										onBlur: function onBlur() {
											props.pageActions.setValidEmail(validateEmail(props.page.email));
										},
										onKeyDown: function onKeyDown(event) {
											if (event.keyCode === 13) {
												attemptSubmit(event);
											}
										},
										type: 'email',
										placeholder: 'Email Address'
									}),
									_react2.default.createElement(
										'div',
										{ className: (props.page.submitAttempted && !props.page.validEmail ? _style2.default.error : '') + ' ' + _style2.default.errorMessage },
										'Please enter a valid email address'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12' },
								_react2.default.createElement(
									'div',
									{ className: 'df-input-group' },
									_react2.default.createElement('i', { className: 'ion-ios-locked-outline' }),
									_react2.default.createElement('input', {
										id: 'passwordInput',
										type: 'password',
										className: 'form-control ' + (props.page.error && _style2.default.inputError),
										placeholder: 'Password'
									}),
									_react2.default.createElement(
										'div',
										{ className: (props.page.error && _style2.default.error) + ' ' + _style2.default.pageErrorMessage + ' text-center' },
										_react2.default.createElement(
											'span',
											null,
											props.page.error && props.page.errorMessage
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.extras },
							_react2.default.createElement(
								'a',
								{ href: '/forgot-password', className: 'text-center' },
								'Forgot your password?'
							),
							_react2.default.createElement(
								'div',
								{ className: 'text-center' },
								_react2.default.createElement('input', {
									onClick: function onClick() {
										props.pageActions.rememberMe(props.page.rememberMeChecked);
									},
									type: 'checkbox',
									id: _style2.default.rememberMeCheckbox
								}),
								_react2.default.createElement(
									'label',
									{ htmlFor: _style2.default.rememberMeCheckbox },
									'Remember Me'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12 text-center' },
								_react2.default.createElement(
									'button',
									{ className: 'btn solid large wide',
										type: 'submit',
										onClick: function onClick(event) {
											props.login({
												password: document.getElementById('passwordInput').value,
												email: props.page.email,
												rememberMe: props.page.rememberMeChecked
											});
											event.preventDefault();
										} },
									'Log in'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.signUp + ' col-xs-12 text-center small-text' },
								'Not a member yet? ',
								_react2.default.createElement(
									'a',
									{ onClick: props.signUpModalActions.openSignUpModal },
									'Sign Up'
								)
							)
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.footerContainer },
				_react2.default.createElement(_footer.Footer, null)
			)
		)
	);
};

LoginPage.propTypes = {
	isAuthenticated: require('react').PropTypes.bool.isRequired,
	session: require('react').PropTypes.object.isRequired,
	page: require('react').PropTypes.object.isRequired,
	pageActions: require('react').PropTypes.object.isRequired,
	signUpModalActions: require('react').PropTypes.object.isRequired,
	login: require('react').PropTypes.func.isRequired
};
LoginPage.displayName = 'LoginPage';

LoginPage.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
	return {
		global: state.global,
		page: state.login.page,
		session: (0, _reduxSimpleAuth.getSessionData)(state),
		isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state)
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		pageActions: (0, _redux.bindActionCreators)(_pageActions.pageActions, dispatch),
		signUpModalActions: (0, _redux.bindActionCreators)(SignUpModalActions, dispatch),
		login: function login(data) {
			dispatch((0, _doctifyUtils.authenticateClient)(data)).catch(console.error);
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginPage);


// WEBPACK FOOTER //
// ./components/login-page/lib/components/login-page.js